import { FC, ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./ActivationLimitEditorButton.scss";

const TOOLTIP_SX = {
    bgcolor: "#707070",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    padding: "8px 13px",
    boxShadow: "0px 4px 8px rgba(255, 244, 244, 0.1)",
};

type Props = {
    icon: string;
    alt?: string;
    onClick?: () => void;
    disabled?: boolean;
    tooltip?: ReactNode;
    className?: string;
};

const ActivationLimitEditorButton: FC<Props> = ({
    icon,
    alt = "action",
    onClick,
    disabled = false,
    tooltip,
    className = "",
}) => {
    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        onClick?.();
    };

    return (
        <Tooltip
            title={!disabled ? tooltip : ""}
            placement="bottom"
            slotProps={{ tooltip: { sx: TOOLTIP_SX } }}
        >
            <span>
                <button
                    type="button"
                    className={`activation_limit_editor_button ${className} ${
                        disabled ? "activation_limit_editor_button--disabled" : ""
                    }`}
                    onClick={handleClick}
                >
                    <img src={icon} alt={alt} />
                </button>
            </span>
        </Tooltip>
    );
};

export default ActivationLimitEditorButton;
